import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addPurchaseOrderApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addPurchaseOrder = createAsyncThunk('addPurchaseOrder', async (payload) => {
  return await addPurchaseOrderApi(payload);
});

const addPurchaseOrderSlice = createSlice({
  name: 'addPurchaseOrder', // Unique Name
  initialState,
  reducers: {
    addPurchaseOrderReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addPurchaseOrder.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addPurchaseOrder.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addPurchaseOrder.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addPurchaseOrderReset } = addPurchaseOrderSlice.actions;

export default addPurchaseOrderSlice.reducer;
